import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { GoldUIProvider, GoldToastProvider, GoldAlertProvider } from "gold-ui-kit";
import { store } from "./store";
import "gold-ui-kit/dist/style.css";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Pages still hardcode light surfaces, so dark mode stays off until they are migrated. */}
    <GoldUIProvider mode="light" locale="tr">
      <GoldToastProvider />
      <GoldAlertProvider />
      <Provider store={store}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Provider>
    </GoldUIProvider>
  </React.StrictMode>
);
